import { useContext, useEffect, useState } from 'react'

import { SupplyChainContext } from 'features/globalSetup/contexts/SupplyChainContext'
import { useWorkspaceParam } from 'features/workspace/hooks/useWorkspaceParam'
import { useQuery } from 'providers/tanstack-query/useQuery'
import { fromDTO, sortToDTO } from './api/mapper'
import { GET_WORKSPACE_BIDDERS_FOR_SUPPLY_CHAIN_TABLE } from './api/query'
import { Data, Variables, WorkspaceBidderForTableDTO } from './api/types'
import { UseGetBidders, UseGetBiddersProps, WorkspaceBidderForTable } from './types'

export const useGetBidders = ({
  filters,
  first,
  last,
  sort,
  supplyChainId,
}: UseGetBiddersProps): UseGetBidders => {
  const { workspaceId } = useWorkspaceParam()
  const { setLoading } = useContext(SupplyChainContext)

  const [bidders, setBidders] = useState<WorkspaceBidderForTable[]>([])
  const [count, setCount] = useState<number>(0)

  const { isLoading } = useQuery<Variables, Data>({
    onCompleted: async (data: Data) => {
      const {
        workspaceBidders: { nodes: bidders, totalCount: count },
      } = data

      if (bidders) {
        setBidders(
          bidders.map(
            (bidder: WorkspaceBidderForTableDTO): WorkspaceBidderForTable => fromDTO(bidder),
          ),
        )
        setCount(count)
      }
    },
    query: GET_WORKSPACE_BIDDERS_FOR_SUPPLY_CHAIN_TABLE,
    variables: {
      first,
      last,
      sort: sortToDTO(sort),
      supplyChainId,
      terms: filters,
      workspaceId,
    },
  })

  useEffect(() => {
    setLoading(isLoading)
  }, [isLoading])

  return { bidders, count }
}
